import SliderInput from "~/components/slider-input.tsx";
import { useTranslator } from "~/i18n/context.tsx";
import { usePicture } from "../context.tsx";
import type { SheetProps } from "../sheet.tsx";
import Sheet from "../sheet.tsx";

function SaturationSheet(props: Pick<SheetProps, "open" | "onDone">) {
	const t = useTranslator();
	const { picture, patchPictureDebounced } = usePicture();

	return (
		<Sheet title={t("Saturation")} {...props}>
			<form onSubmit={(e) => e.preventDefault()}>
				<SliderInput
					min={0}
					max={100}
					step={1}
					value={Math.round(picture.saturation * 100)}
					onChange={(newValue) =>
						patchPictureDebounced({
							saturation: newValue / 100,
						})
					}
				/>
			</form>
		</Sheet>
	);
}

export default SaturationSheet;
